import { Headline } from '@shipt/design-system-typography'
import styled from 'styled-components'
import { ProductDetailCustomerReview } from '@/features/shop/components/ProductDetailRatingsAndReviews/ProductDetailCustomerReview'
import { HDivider } from '@/features/shared/components/Dividers'
import { type Review } from '@/features/account/services/RatingsAndReviews/types'
import { Column, Row } from '@shipt/design-system-layouts'
import { SelectElement } from '@shipt/design-system-select'
import { type Dispatch, type SetStateAction } from 'react'
import { SortAltIcon } from '@shipt/design-system-icons'
interface Props {
  reviews: Review[]
  setSortByValue: Dispatch<SetStateAction<string>>
  defaultValue: string
}

export const ProductDetailReviews = ({ reviews, setSortByValue, defaultValue }: Props) => {
  if (reviews.length < 1) return null

  return (
    <Column
      role="region"
      aria-labelledby="reviews-heading"
      paddingTop="xl"
      paddingLeft={{ base: 0, lg: '3xl' }}
    >
      <Row justify="space-between" align="center">
        <Headline size="md" id="reviews-heading">
          Reviews
        </Headline>
        <SelectElement
          aria-label="Sort by"
          size="md"
          name="sortBy"
          options={[
            { value: '', label: 'Sort by: ', disabled: true },
            { value: 'newest', label: 'Newest' },
            { value: 'oldest', label: 'Oldest' },
            { value: 'highest_rated', label: 'Highest rated' },
            { value: 'lowest_rated', label: 'Lowest rated' },
          ]}
          defaultValue={defaultValue}
          onChange={(e) => setSortByValue(e.target.value)}
          leading={<SortAltIcon size="sm" />}
        />
      </Row>
      <ReviewsList>
        {reviews.map((review, i) => (
          <ReviewItem key={review.id} role="listitem">
            <ProductDetailCustomerReview review={review} />
            {i !== reviews.length - 1 && <HDivider />}
          </ReviewItem>
        ))}
      </ReviewsList>
    </Column>
  )
}

const ReviewsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const ReviewItem = styled.li`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`
